<template>
  <div data-scroll-container>
    <div data-scroll-section>
      <div class="row justify-content-center align-items-center h-100" :class="{'mt-md-0 mt-11' : $root.isDevice}">
        <div class="col-xxl-14 col-xl-16">
          <div class="row">
            <div class="col-16">
              <div class="row no-gutters">
                <div
                  class="col-xxl-8 col-lg-10 col-md-9 col-10 text-sm-justify mt-xxl-6 mt-xl-10 mt-sm-6"
                >
                  <h1 class="title text-stack">about</h1>
                  <p class="xxsmall text-stack lh-sm-20 lh-15 mt-xxl-5 mt-3">
                    Hi I’m Nicky a photographer based in Athens available
                    worldwide! I originally studied architecture but I was
                    constantly inspired by photography, a hobby that was always
                    there but never thought of it as a profession. I realised my
                    love for light and I quickly transitioned to the world of
                    photography. Although I love shooting action sports and
                    commercial work, my strongest passion is photographing
                    people, creating stories that become visual inheritance for
                    years to come.
                  </p>

                  <ul class="page-links mt-10 d-lg-flex d-none">
                    <li>
                      <router-link :to="{ name: 'contact' }" class=""
                        >work with me</router-link
                      >
                    </li>
                    <li>
                      <router-link :to="{ name: 'portfolio' }" class=""
                        >view work</router-link
                      >
                    </li>
                  </ul>
                </div>

                <div
                  class="col-xxl-5 col-xl-4 col-lg-5 col-6 offset-xl-2 offset-md-1 text-lg-left text-right"
                >
                  <img
                    src="/public/site/nickyeconomou/dist/images/about.jpg"
                    class="img-fluid pl-md-0 pl-sm-6 pl-3"
                    alt="NickyEconomou"
                    @load="setPageReady()"
                  />
                </div>

                <div class="col-16 mt-lg-0 mt-3 d-lg-none">
                  <ul class="page-links">
                    <li>
                      <router-link :to="{ name: 'contact' }" class=""
                        >work with me</router-link
                      >
                    </li>
                    <li>
                      <router-link :to="{ name: 'portfolio' }" class=""
                        >view work</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setPageReady() {
      this.$root.setLoaderPercentage(100);

      setTimeout(() => {
        this.$store.dispatch("togglePageReady", true);
      }, this.$root.loaderCountDuration - 2000);
    },
  },
};
</script>

<style lang="scss">
@import "src/sass/variables";
@import "src/sass/mixins";
@import "node_modules/bootstrap/scss/vendor/rfs";

.page-links {
  @include ul-nostyle;
  display: flex;
  align-items: center;

  li {
    margin-right: 50px;
    padding-right: 50px;
    position: relative;

    a {
      @include font-size(1.875rem);
      font-weight: $font-weight-thin;
      color: $stack;
      letter-spacing: 0.5rem;

      &:hover {
        color: $white;
      }
    }

    &::after {
      content: "//";
      @include font-size(1.875rem);
      font-weight: $font-weight-thin;
      line-height: 1;
      color: $stack;
      display: block;
      position: absolute;
      right: 0;
      top: 55%;
      transform: translate(50%, -50%);
    }

    &:last-child {
      margin-right: 0px;
      padding-right: 0px;

      &::after {
        content: unset;
      }
    }
  }
}
</style>